import * as React from 'react'
import {
    Container as RSContainer,
    Draggable as RSDraggable
} from '@richardrout/react-smooth-dnd'
import { OnDropCallback } from '@richardrout/react-smooth-dnd'

import { Lane } from './list'
import { DroppableListType } from './dtos'
import { DragDropListsContainer, UseDragDropListsProps } from './hooks'

import * as styles from './DnDLists.module.less'
import * as scrollbarStyles from './scrollbar-styles/FancyScrollbar.module.less'

export type DnDListsProps = UseDragDropListsProps

export const DnDLists: React.FC<DnDListsProps> = (props) => {
    return (
        <DragDropListsContainer.Provider initialState={props}>
            <DragDropListsInner />
        </DragDropListsContainer.Provider>
    )
}

const DragDropListsInner: React.FC = React.memo(() => {
    const {
        components,
        onDropList,
        state
    } = DragDropListsContainer.useContainer()

    let ListHeader: React.ElementType<any>
    if (components) {
        ListHeader = components.ListHeader
    }

    const onDrop: OnDropCallback = (e) => {
        const args = {
            // @ts-ignore
            id: state.listOrder[e.removedIndex],
            sourceIndex: e.removedIndex,
            targetIndex: e.addedIndex,
            type: DroppableListType
        }
        onDropList(e)
    }

    const lists = state.listOrder.map((colId: string) => {
        const list = state.lists[colId]
        if (!list) {
            return null
        }
        const items = list?.itemIds
            .map((itemId: string) => state.items[itemId])
            // @ts-ignore
            .filter((i) => i) // gets rid of undefined

        return (
            <RSDraggable key={list.id}>
                <Lane
                    list={list}
                    Header={
                        <ListHeader className="list-drag-handle" list={list} />
                    }
                    items={items}
                    filter={state?.filter}
                />
            </RSDraggable>
        )
    })

    return (
        <div className={`${styles.board} ${scrollbarStyles.fancyScrollbar}`}>
            <RSContainer
                disableScrollOverlapDetection={true}
                dragHandleSelector=".list-drag-handle"
                dropPlaceholder={{
                    animationDuration: 100,
                    showOnTop: true,
                    className: 'cards-drop-preview'
                }}
                onDrop={onDrop}
                autoScrollEnabled={true}
                orientation="horizontal"
            >
                {lists}
            </RSContainer>
        </div>
    )
})
